import routes from "actions/routes";
import { generateCreateActionCreator } from "actions/crudActionCreators";
import ACTION_NAMES from "actions/ACTION_NAMES";

export default {
    start: generateCreateActionCreator(routes.API_DIALER_START, ACTION_NAMES.DIALER_START),
    pressed: generateCreateActionCreator(routes.API_PRESSED, ACTION_NAMES.PRESSED),
    next: generateCreateActionCreator(routes.API_DIALER_NEXT, ACTION_NAMES.DIALER_NEXT),
    end: generateCreateActionCreator(routes.API_DIALER_END, ACTION_NAMES.DIALER_END),
}
